import { useEffect, useState } from "react";
import AppCtrl from "../../control/AppCtrl";
import useAlert from "../../hook/useAlert";
import useRsgGames from "../../redux/rsgGames/rsgGamesAction";
import useUserCoins from "../../redux/userCoins/userCoinsAction";
import Config from "../../utils/Config";
import EPage from "../../utils/EPage";
import LANGUAGE_TYPE from "../../utils/Language";
import Utils from "../../utils/Utils";
import BroadcastPanel from "../BroadcastPanel";
import Banners from "../MainPage/WinLobbyPage/Banners";
import styles from "./index.module.scss";

const index = () => {
  const { userCoins } = useUserCoins();
  const { games: rsgGames } = useRsgGames();
  const { showAlert } = useAlert();

  const [forceVerticalMode] = useState(() =>
    Config.forceVerticalMode ? Config.forceVerticalMode : false
  );
  const [mobileMode] = useState(() => Utils.detectmob() || forceVerticalMode);

  const leaveRsgGames = () => {
    AppCtrl.switchPage(EPage.main);
    const msg = `正在回到主頁面\n請稍候。`;
    showAlert({ title: msg, showConfirmButton: false, timer: 2000 });
  };

  const onClickRsgGame = (game) => {
    const userInfo = AppCtrl.userInfo();

    const enablePlayAccount = [
      "GPS",
      "GPS1",
      "GPS2",
      "GPS3",
      "GPS4",
      "GPS5",
      "GPS6",
      "Frank",
      "Howard",
      "Test",
    ];

    if (!enablePlayAccount.includes(userInfo.Account)) {
      showAlert({ title: "敬請期待! 該功能即將開放" });
      return;
    }

    if (userInfo.InCoins - userInfo.OutCoins <= 0) {
      showAlert({ title: "您的帳號餘額不足，無法進入RSG遊戲" });
      return;
    }

    AppCtrl.requestJoinRsgGames(game.GameId);
    AppCtrl.switchPage(EPage.rsgGame);
  };

  function onChat() {
    const liveChat = Config.liveChat ? Config.liveChat : "";
    const withAPIGame = Config?.withAPIGame ?? false;
    if (liveChat != "" && !withAPIGame) {
      window.open(liveChat);
    }
  }

  useEffect(() => {
    let body = document.querySelector("body");
    if (mobileMode) {
      body.style.overflowY = "auto";
    }
    const mainSettings = AppCtrl.mainSettings();
    const language = AppCtrl.getLanguage();
    const userInfo = AppCtrl.userInfo();

    const uiUserInfos = document.getElementById("userInfos");
    if (uiUserInfos) {
      const goldName = Config.gold[language];
      const silverName = Config.silver[language];
      const wainZhusName = Config.wainZhuName[language];
      const paiedAwardName = Config.paiedAwardName[language];
      const betRewardName = Config.betRewardName[language];
      const guoZhaoInfo = userInfo.GuoZhaoInfo;
      const specialCoinName = Config.specialCoins[language];
      const specialCoinNameA = Config.specialCoinsA[language];

      let content =
        '<div style="padding:2px; background-color:rgba(0, 0, 0, 0.2); border-radius:10px">';
      if (language == LANGUAGE_TYPE.en_US) {
        content += `<div>User: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (on Guo Zhao, Machine ${machineName} of Lobby ${guoZhaoInfo.Lobby})`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (use Machine ${machineName} of Lobby ${lockedMachine.Lobby})`;
        }
        content += "</div>";
      } else {
        const now = new Date();
        const dateStr = now.toLocaleString("zh-TW", {
          hour12: false,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        content += `<div>${dateStr}</div>`;

        content += `<div>玩家: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (正在${guoZhaoInfo.Lobby}館的機台${machineName}過招中)`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (使用${lockedMachine.Lobby}館的機台${machineName})`;
        }
        content += "</div>";
      }
      content += `<div>${goldName}: ${(
        userInfo.InCoins - userInfo.OutCoins
      ).toLocaleString()}</div>`;
      if (Config.trialCoins) {
        content += "<div>";
        content += `<span>${silverName}: ${(
          userInfo.InTrialCoins - userInfo.OutTrialCoins
        ).toLocaleString()}</span>`;
        if (userInfo.PaiedAward != null)
          content += `<span style="margin-left:20px">${paiedAwardName}: ${userInfo.PaiedAward.toLocaleString()}</span>`;
        content += "</div>";
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinName}: ${(
          userInfo.InSpecialCoins - userInfo.OutSpecialCoins
        ).toLocaleString()}</div>`;
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinNameA}: ${(
          userInfo.InSpecialCoinsA - userInfo.OutSpecialCoinsA
        ).toLocaleString()}</div>`;
      }
      if (Config.wainZhu && userInfo.WainZhus != null) {
        if (typeof userInfo.WainZhus != "object")
          AppCtrl.setWainZhu(userInfo.WainZhus);
        const wainZhu = AppCtrl.WainZhu();
        content += `<div>${wainZhusName}:${wainZhu.toLocaleString()}</div>`;
      }
      if (mainSettings.ShowBetReward && userInfo.BetReward != null) {
        content += "<div>";
        content += `<span>${betRewardName}: ${userInfo.BetReward.toLocaleString()}</span>`;
        content += "</div>";
      }
      const showPlayerLevel = AppCtrl.showPlayerLevel();
      if (showPlayerLevel > 0) {
        //img:"img/gamelobby/銀卡.png",
        const permission =
          userInfo.Permission >= showPlayerLevel
            ? showPlayerLevel
            : userInfo.Permission;
        const imgLevel = `img/gamelobby/VipCard${permission.toString()}.png`;

        content += `<div id='VipCard'> 
                <img src="${imgLevel}" style="position:relative; left:0; top:10px; width:30%; object-fit:contain"/>
                </div>`;
      }
      content += "</div>";
      uiUserInfos.innerHTML = content;
    }

    const userInfos_horizontalmode = document.getElementById(
      "userInfos_horizontalmode"
    );
    if (userInfos_horizontalmode) {
      // //------------------UserInfos------------------
      const mainSettings = AppCtrl.mainSettings();
      const language = AppCtrl.getLanguage();
      const userInfo = AppCtrl.userInfo();
      const goldName = Config.gold[language];
      const silverName = Config.silver[language];
      const wainZhusName = Config.wainZhuName[language];
      const paiedAwardName = Config.paiedAwardName[language];
      const betRewardName = Config.betRewardName[language];
      const guoZhaoInfo = userInfo.GuoZhaoInfo;
      const specialCoinName = Config.specialCoins[language];
      const specialCoinNameA = Config.specialCoinsA[language];

      const deviceHeight = window.innerHeight;
      const contentHeight = deviceHeight - 90 - 85; //BTNTopBar-horizontal(40px)+broadcastPanel(30px);+content_horizontal(85px)
      const infoHeight = contentHeight * 0.6;
      const infoWidth = infoHeight;
      const topOffsetInfo = (contentHeight - infoHeight) / 2;

      let userInfosContent = "";
      let content = "";
      //顯示玩家暱稱
      if (language == LANGUAGE_TYPE.en_US) {
        content += `<div>User: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (on Guo Zhao, Machine ${machineName} of Lobby ${guoZhaoInfo.Lobby})`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (use Machine ${machineName} of Lobby ${lockedMachine.Lobby})`;
        }
        content += "</div>";
      } else {
        const now = new Date();
        const dateStr = now.toLocaleString("zh-TW", {
          hour12: false,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        content += `<div>${dateStr}</div>`;

        content += `<div>玩家: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (正在${guoZhaoInfo.Lobby}館的機台${machineName}過招中)`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (使用${lockedMachine.Lobby}館的機台${machineName})`;
        }
        content += "</div>";
      }

      //顯示玩家的金幣數量
      content += `<div>${goldName}: ${(
        userInfo.InCoins - userInfo.OutCoins
      ).toLocaleString()}</div>`;

      //顯示玩家的銀幣數量
      if (Config.trialCoins) {
        content += `<div>${silverName}: ${(
          userInfo.InTrialCoins - userInfo.OutTrialCoins
        ).toLocaleString()}</div>`;
      }

      //顯示玩家的特殊幣數量
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinName}: ${(
          userInfo.InSpecialCoins - userInfo.OutSpecialCoins
        ).toLocaleString()}</div>`;
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinNameA}: ${(
          userInfo.InSpecialCoinsA - userInfo.OutSpecialCoinsA
        ).toLocaleString()}</div>`;
      }

      //顯示玩家的每日贈獎數量
      if (userInfo.PaiedAward != null) {
        content += `<div">${paiedAwardName}: ${userInfo.PaiedAward.toLocaleString()}
          </div>`;
      }

      //顯示玩家返水數量
      if (mainSettings.ShowBetReward && userInfo.BetReward != null) {
        content += `<div>${betRewardName}: ${userInfo.BetReward.toLocaleString()}
          </div>`;
      }

      //顯示玩家萬珠數量,目前已經停用
      if (Config.wainZhu && userInfo.WainZhus != null) {
        if (typeof userInfo.WainZhus != "object")
          AppCtrl.setWainZhu(userInfo.WainZhus);
        const wainZhu = AppCtrl.WainZhu();
        content += `<div>${wainZhusName}:${wainZhu.toLocaleString()}
          </div>`;
      }

      //顯示玩家等級
      const showPlayerLevel = AppCtrl.showPlayerLevel();
      if (showPlayerLevel > 0) {
        //img:"img/gamelobby/銀卡.png",
        const permission =
          userInfo.Permission >= showPlayerLevel
            ? showPlayerLevel
            : userInfo.Permission;
        const imgLevel = `img/gamelobby/VipCard${permission.toString()}.png`;
        const cardWidth = 0.3 * infoWidth; // 30% of infoWidth

        content += `<div id='VipCard'> 
                <img src="${imgLevel}" style="position:absolute;right:0px;top:${topOffsetInfo}px;
                padding-top:200px; width:${cardWidth}px; object-fit:contain"/>
                </div>`;
      }
      userInfosContent += content;
      userInfosContent += `</div></div>`;
      // //------------------End UserInfos------------------
      userInfos_horizontalmode.innerHTML = userInfosContent;
    }
  }, [userCoins]);

  useEffect(() => {
    const uiShowTitle = document.getElementById("showTitle");
    const ShowTitle = Config.showTitle ? Config.showTitle : Config.casinoName;
    if (uiShowTitle && ShowTitle != "") {
      uiShowTitle.innerHTML = ShowTitle;
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.mainArea}>
        <div
          className={styles.header}
          style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
        >
          <input
            id="exitButton"
            type="image"
            src="img/lobbyui/exit.png"
            style={{
              margin: "0 1px",
              float: "right",
              width: "35%",
              maxWidth: "50px",
              maxHeight: "50px",
            }}
            onClick={leaveRsgGames}
          ></input>
          <input
            id="chatButton"
            type="image"
            src="img/lobbyui/chat.png"
            style={{
              margin: "0 1px",
              float: "left",
              width: "35%",
              maxWidth: "50px",
              maxHeight: "50px",
            }}
            onClick={onChat}
          ></input>
          <label
            id="showTitle"
            style={{
              paddingLeft: "10px",
              margin: "15px auto",
              float: "center",
              fontSize: "24px",
            }}
          />
        </div>
        <div className={styles.broadcastbar}>
          <BroadcastPanel />
        </div>
        <div className={styles.content}>
          <Banners />
          <div
            id="userInfos"
            className={styles.userInfoPage}
            style={{ float: "left", margin: "0px 10px", width: "55%" }}
          ></div>
          <div id="atgGames" className={styles.atgGames}>
            {rsgGames?.map((game) => (
              <div
                key={game.gameId}
                className={styles.atgGame}
                onClick={() => onClickRsgGame(game)}
              >
                <div className={styles.atgGameName}>
                  <span style={{ marginLeft: "5px" }}>
                    {" "}
                    {game.GameName.zh_TW}
                  </span>
                </div>
                {game.GameId === 112 ? (
                  <img
                    src={"img/lobbyui/thorLobby.gif"}
                    alt={game.GameName.zh_TW}
                    className={styles.atgGameImg}
                  />
                ) : (
                  <img
                    src={`img/lobbyui/${game.GameId}.png`}
                    alt={game.GameName.zh_TW}
                    className={styles.atgGameImg}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
